import script from "./SideTabBar.vue?vue&type=script&setup=true&lang=js"
export * from "./SideTabBar.vue?vue&type=script&setup=true&lang=js"

import "./SideTabBar.vue?vue&type=style&index=0&id=c5d56884&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5d56884"]])

export default __exports__